const cardItems = [
  {
    title: '2026暑期综艺大盘点：谁在霸屏谁在翻车',
    excerpt: '暑期档综艺大战进入白热化阶段，从选秀到真人秀，从恋综到音综，各家平台拿出看家本领。本文逐一分析各档节目的口碑与热度表现。',
    tag: '深度分析',
    img: 'https://readdy.ai/api/search-image?query=A%20modern%20TV%20production%20control%20room%20with%20multiple%20screens%20showing%20different%20shows%2C%20professional%20broadcast%20environment%2C%20warm%20studio%20lighting%2C%20editorial%20media%20analysis%20style%2C%20clean%20composition&width=640&height=420&seq=card-01&orientation=landscape',
  },
  {
    title: '娱乐圈「人设经济学」：为什么明星都在立人设',
    excerpt: '从学霸到吃货，从耿直到老干部，人设已成为明星商业价值的重要组成部分。但人设崩塌的代价也越来越高，这背后是一门复杂的商业逻辑。',
    tag: '行业观察',
    img: 'https://readdy.ai/api/search-image?query=An%20artistic%20concept%20of%20celebrity%20branding%20and%20public%20image%2C%20split%20mask%20design%20with%20spotlight%20and%20shadow%2C%20warm%20dramatic%20lighting%2C%20editorial%20conceptual%20photography%20style&width=640&height=420&seq=card-02&orientation=landscape',
  },
  {
    title: '从素人到顶流：网红产业链背后的资本博弈',
    excerpt: 'MCN机构、平台算法、资本运作——一个网红的诞生远比你想象的复杂。揭秘网红经济背后的产业链条与商业逻辑。',
    tag: '产业揭秘',
    img: 'https://readdy.ai/api/search-image?query=A%20modern%20office%20with%20data%20analytics%20dashboards%20and%20social%20media%20metrics%20displays%2C%20corporate%20tech%20environment%2C%20warm%20ambient%20lighting%2C%20professional%20business%20photography%20style&width=640&height=420&seq=card-03&orientation=landscape',
  },
  {
    title: '古装剧服化道进化史：从粗制滥造到匠心之作',
    excerpt: '回顾近十年古装剧的服化道变迁，从早期的艳俗配色到如今的考究还原，中国古装剧的美学水准经历了质的飞跃。',
    tag: '文化解读',
    img: 'https://readdy.ai/api/search-image?query=A%20beautiful%20traditional%20Chinese%20costume%20display%20with%20intricate%20embroidery%20and%20fabric%20details%2C%20museum%20quality%20presentation%2C%20warm%20soft%20lighting%2C%20cultural%20heritage%20photography%20style&width=640&height=420&seq=card-04&orientation=landscape',
  },
  {
    title: '选秀回锅肉现象：为什么同一批人在反复参赛',
    excerpt: '选秀节目中出现越来越多熟悉的面孔，「回锅肉」选手已成为行业常态。这背后既有选手的不得已，也有节目组的商业考量。',
    tag: '现象解读',
    img: 'https://readdy.ai/api/search-image?query=A%20dramatic%20stage%20performance%20scene%20with%20spotlights%20and%20audience%20silhouettes%2C%20talent%20show%20atmosphere%2C%20warm%20theatrical%20lighting%2C%20concert%20photography%20style%2C%20clean%20composition&width=640&height=420&seq=card-05&orientation=landscape',
  },
  {
    title: '短视频时代的明星生存法则：流量为王还是作品说话',
    excerpt: '当短视频成为主要传播渠道，明星的生存策略也在悄然改变。有人拥抱流量，有人坚守作品，两种路线的博弈愈演愈烈。',
    tag: '趋势探讨',
    img: 'https://readdy.ai/api/search-image?query=A%20creative%20concept%20of%20smartphone%20screen%20displaying%20social%20media%20feed%20with%20video%20thumbnails%2C%20modern%20digital%20lifestyle%2C%20warm%20ambient%20lighting%2C%20editorial%20tech%20photography%20style&width=640&height=420&seq=card-06&orientation=landscape',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-accent-100/80 text-accent-800 text-xs font-medium mb-3">
            <i className="ri-article-line text-sm"></i>
            热门专题
          </span>
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950">
            热门专题
          </h2>
          <p className="text-foreground-500 text-sm mt-2">深度好文，带你读懂娱乐圈</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {cardItems.map((item, i) => (
            <article
              key={i}
              className="group bg-background-100 rounded-xl overflow-hidden border border-background-200/70 hover:border-accent-300/60 transition-all duration-300 cursor-pointer flex flex-col"
            >
              <div className="relative aspect-[3/2] overflow-hidden bg-background-200">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-accent-500/90 text-background-50 text-xs font-medium backdrop-blur-sm">
                  {item.tag}
                </span>
              </div>
              <div className="p-4 md:p-5 flex flex-col flex-1">
                <h3 className="font-heading font-semibold text-base md:text-lg text-foreground-900 leading-snug mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-foreground-500 text-sm leading-relaxed line-clamp-3 flex-1">
                  {item.excerpt}
                </p>
                <div className="mt-4 pt-3 border-t border-background-200/70 flex items-center justify-between">
                  <span className="text-xs text-foreground-400">
                    <i className="ri-eye-line mr-1"></i>阅读全文
                  </span>
                  <span className="text-xs text-foreground-400">
                    <i className="ri-time-line mr-1"></i>8分钟
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}